// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusMinusInput_wrapper__0XRXt","dirty":"PlusMinusInput_dirty__-nf7o","button":"PlusMinusInput_button__GpdM2"};